// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1__st","cls2":"ResearchInterestDirectorySearch-cls2_LAJ ResearchInterestDirectorySearch-cls1__st"};